import {
    CreateUser
} from '../../config/fireConfig';
import * as actions from '../actions';

export const signIn = (credentials) => {

    return (dispatch, getState, {
        getFirebase
    }) => {

        dispatch({
            type: actions.LOGIN_START
        })

        const firebase = getFirebase();
        firebase.auth().signInWithEmailAndPassword(
            credentials.email,
            credentials.password
        ).then((data) => {
            dispatch({
                type: actions.LOGIN_SUCCESS
            })
        }).catch((err) => {
            dispatch({
                type: actions.LOGIN_ERROR,
                payload: err
            })
        })
    }
}

export const signOut = () => {

    return (dispatch, getState, {
        getFirebase
    }) => {

        const firebase = getFirebase();

        firebase.auth().signOut(

        ).then(() => {

            dispatch({
                type: 'SIGNOUT_SUCCES'
            })
        })
    }
}


export const createNewUser = (newUser) => {
    return (dispatch, getState, {
        getFirestore
    }) => {
        dispatch({
            type: actions.CREATE_USER_START
        })
        const firestore = getFirestore();
        CreateUser.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then((resp) => {
            CreateUser.auth().signOut();

            const userData = {
                ...newUser,
                initials: newUser.firstName[0] + newUser.lastName[0],
                displayName: newUser.firstName + ' ' + newUser.lastName,
                createdAt: new Date(),
                id: resp.user.uid
            }
            delete userData.password;

            return firestore.collection('users').doc(resp.user.uid).set({
                ...userData
            }).then(() => {
                dispatch({
                    type: actions.CREATE_USER_SUCCESS,
                    payload: {}
                })
            }).catch(err => {
                dispatch({
                    type: actions.CREATE_USER_ERROR,
                    payload: err
                })
            })
        }).catch(err => {
            dispatch({
                type: actions.CREATE_USER_ERROR,
                payload: err
            })
        })
    }
}

export const createUseReset = () => {
    return (dispatch, getState, {
        getFirestore
    }) => {
        dispatch({
            type: actions.CREATE_USER_RESET
        })
    }
}


export const signUp = (newUser) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.SIGNUP_START
        })
        const firebase = getFirebase();
        const firestore = getFirestore();
        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then((resp) => {
            const userData = {
                ...newUser,
                initials: newUser.firstName[0] + newUser.lastName[0],
                displayName: newUser.firstName + ' ' + newUser.lastName,
                createdAt: new Date(),
            }
            delete userData.password;
            return firestore.collection('users').doc(resp.user.uid).set({
                ...userData
            })

        }).then(() => {
            dispatch({
                type: actions.SIGNUP_SUCCESS,
                payload: {}
            })
        }).catch(err => {

            dispatch({
                type: actions.SIGNUP_ERROR,
                payload: err
            })
        })

    }
}